// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cgxpouqbbvdmsfuyaitc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImNneHBvdXFiYnZkbXNmdXlhaXRjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU3NjU5NDMsImV4cCI6MjA2MTM0MTk0M30.dekXWzmOKilKG3oInit-SCzxLK00Y8H02TTTkPWEHE8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);